export default __webpack_public_path__ + "static/media/330_store03-nl-web.b13a9fd0.png";